/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { mapLayoutData } from './layoutData.mapper';
import { FetchLayoutDataParams, LayoutData, RawLayoutData } from './types';

export type {
  CurrencyInfo,
  FetchLayoutDataParams,
  LayoutData,
  RawLayoutData,
} from './types';

const getCmnBaseUrl = (env: string) =>
  env === 'prd'
    ? 'https://cs-next.airasia.com'
    : 'https://cs-next.stgairasia.com';

export const fetchLayoutData = async ({
  env,
  apiKey,
  slug,
  platform = 'web',
  locale = 'en-gb',
  geoId = 'ZZ',
}: FetchLayoutDataParams): Promise<LayoutData> => {
  const query = new URLSearchParams({
    geoId,
    locale,
    platform,
  }).toString();
  const endpoint = `${getCmnBaseUrl(env)}/v1/content/platforms/header_footer${slug ? `/${slug}` : ''}?${query}`;

  const response = await fetch(endpoint, {
    headers: {
      'X-API-Key': apiKey,
    },
    // Cache response on Next.js server for 5 minutes
    next: { revalidate: 300 },
  } as RequestInit);

  if (!response.ok) {
    throw new Error(
      `Failed to fetch layout data: ${response.status} ${response.statusText}`,
    );
  }

  const result = (await response.json()) as {
    success: boolean;
    data: RawLayoutData;
  };

  if (!result?.data) {
    throw new Error('No layout data returned from content service');
  }

  return mapLayoutData(result.data);
};
